<template>
    <div>
        <g-header></g-header>
        <el-row class="no-find-box">
            <el-row>
                <img src="../../assets/images/404.png" alt="404">
            </el-row>
            <p>你要找的页面不见了</p>
        </el-row>
        <g-footer></g-footer>
    </div>
</template>

<script>
import GHeader from '@/layout/GHeader';
import GFooter from '@/layout/GFooter';
export default {
    components: {
        GHeader,
        GFooter,
    },
}
</script>

<style lang="scss" scoped>
.no-find-box {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    img {
        width: 424px;
        height: 228px;
        margin-top: 200px;
        
    }
    p {
        font-size: 16px;
        font-weight: 400;
        color: #909399;
        text-align: center;
        margin-top: 22px;
        margin-bottom: calc(100% - 1000px);
    }
}
</style>